<template>
    <div class="mb-3">

        <!-- 面積 -->
        <div>

            <div class="input-style">
                <b-input-group class="mb-3">
                    <b-input-group-prepend>
                        <b-input-group-text>
                            <i :class="$tools.style.classIcon('area')"></i> {{ $t('menu.' + i18nArea) }}
                        </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="number" class="form-control"
                                step="0.0001" max="9999999" min="0"
                                @input="computeValue_area(selected_unit, selected_unit)"
                                v-model.number="input_area" />
                </b-input-group>
            </div>
            <b-form-select v-model="selected_unit" class="select-unit">
                <option v-for="(unit, idx_u) in units" :key="idx_u + '-area-d'" :value="unit" class="radio-unit">
                    <span v-html="$t( 'u.' + unit )"></span>
                </option>
            </b-form-select>
            <div class="converted-value">
                =
                <span v-if="computed_area_save_unit">{{ computed_area_save_unit }}</span>
                <span v-else> --- </span>
                <span v-html="' ' + $t( 'u.' + save_unit )"></span>
            </div>

        </div>


        <!-- 單位密度 -->
        <div v-if="pageType == 'cropperiod'">

            <div class="input-style">
                <b-input-group class="mb-3">
                    <b-input-group-prepend>
                        <b-input-group-text>
                            <i :class="$tools.style.classIcon('area')"></i> {{ $t('menu.planting_density') }}
                        </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="number" class="form-control"
                                step="0.0001" max="9999999" min="0"
                                @input="computeValue_density(selected_unit, selected_unit)"
                                v-model.number="input_density" />
                </b-input-group>
            </div>
            <b-form-select v-model="selected_unit" class="select-unit-density">
                <option v-for="(unit, idx_u) in units" :key="idx_u + '-density-d'" :value="unit" class="radio-unit">
                    <span v-html="$t('n.plants') + '/' + $t( 'u.' + unit )"></span>
                </option>
            </b-form-select>
            <div class="converted-value">
                =
                <span v-if="computed_density_save_unit">{{ computed_density_save_unit }}</span>
                <span v-else> --- </span>
                <span v-html="' ' + $t('n.plants') + '/' + $t( 'u.' + save_unit )"></span>
            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: {
        pageType: {
            type: String,
            default: 'project',
        },
        area: {
            type: Number,
        },
        density: {
            type: Number,
        },
        defaultUnit: {
            type: String,
            default: 'm2',
        },
        timezone: {
            type: String,
            default: 'Asia/Taipei'
        },
    },
    data () {
        return {
            i18nArea: 'field_area',
            showDensity: false,

            units: this.$tools.unit.area_units.default, //[ 'm2', 'ha', 'acre' ],
            selected_unit: 'm2',
            input_area: undefined,
            input_density: undefined,

            // 要存到資料庫的單位
            save_unit: 'm2',
            computed_area_save_unit: undefined,
            computed_density_save_unit: undefined,
        }
    },
    mounted () {

        this.setPageInfo();

        if (this.timezone == 'Asia/Taipei') { this.units = this.$tools.unit.area_units.taiwan; } //[ 'm2', 'ha', 'hun', 'kah', 'acre' ]; }

        this.input_area = this.area;
        this.input_density = this.density;

        this.selected_unit = this.defaultUnit;

    },
    watch:
    {
        area (val, oldVal)
        {
            this.input_area = val;
        },
        density (val, oldVal)
        {
            this.input_density = val;
        },

        selected_unit (val, oldVal)
        {
            this.computeValue_area(val, oldVal);
            this.computeValue_density(val, oldVal);
        },

    },
    methods: {

        setPageInfo ()
        {
            this.showDensity = false;
            switch (this.pageType)
            {
                case 'project':     this.i18nArea = 'project_area'; break;
                case 'cropperiod':  this.i18nArea = 'field_area'; this.showDensity = true; break;
                default:            this.i18nArea = 'project_area'; break;
            }
        },

        computeValue_area (val, oldVal)
        {
            if (oldVal && val)
            {
                this.computed_area_save_unit = this.$tools.unit.area_unit_convert( val, this.save_unit, this.input_area );
                this.$emit('update-area', this.computed_area_save_unit);
            }
        },

        computeValue_density (val, oldVal)
        {
            if (oldVal && val)
            {
                this.computed_density_save_unit = this.$tools.unit.density_unit_convert( val, this.save_unit, this.input_density );
                this.$emit('update-density', this.computed_density_save_unit);
            }
        },

    },
}
</script>


<style lang="scss" scoped>

.converted-value
{
    display: inline-block;
    margin-left: 10px;
}

.input-style
{
    display: inline-block;
    width: 250px;
}

.select-unit
{
    display: inline-block;
    width: 80px;
    padding-left: 2px;
}
.select-unit-density
{
    display: inline-block;
    width: 110px;
    padding-left: 2px;
}

</style>

